import * as React from "react";
import BaseComponent from "components/BaseComponent";
import SelectScriptModules from "./SelectScriptModules";
import InternalLink from "components/InternalLink/InternalLink";
import {DeploymentProcessResource} from "client/resources/deploymentProcessResource";
import {LifecycleResource} from "client/resources/lifecycleResource";
import {EnvironmentResource} from "client/resources/environmentResource";
import LifecycleMap from "areas/library/components/Lifecycle/LifecycleMap/LifecycleMap";
import SelectLifecycle from "areas/projects/components/DeploymentProcess/SelectLifecycle";
import OpenDialogButton from "components/Dialog/OpenDialogButton";
import {Permission} from "client/resources";
import PermissionCheck from "components/PermissionCheck/PermissionCheck";
import {isAllowed} from "components/PermissionCheck/PermissionCheck";
import Callout, {CalloutType} from "components/Callout/Callout";
import styles = require("./style.less");
import routeLinks from "../../../../routeLinks";
import Note from "components/form/Note/Note";

interface SideBarProps {
    deploymentProcess: DeploymentProcessResource;
    includedScriptModules: ScriptModule[];
    lifecyclePreview: LifecycleResource;
    environmentsById?: { [id: string]: EnvironmentResource; };
    onDataChanged: () => any;
}

export interface ScriptModule {
    Id: string;
    Name: string;
}

export default class SideBar extends BaseComponent<SideBarProps, any> {

    render() {
        return (
            <div>
                <PermissionCheck permission={Permission.LifecycleView}
                    alternate={<Callout type={CalloutType.Information}>
                        The {Permission.LifecycleView} permission is required to view the Lifecycle
                    </Callout>}>
                    {this.props.lifecyclePreview && <div>
                        <h4>Lifecycle</h4>
                            <Note>Lifecycles can be defined in the <InternalLink to={routeLinks.library.lifecycles}>Library</InternalLink></Note>
                        <span className={styles.lifeCycleName}>{this.props.lifecyclePreview.Name}</span>
                        <LifecycleMap environmentsById={this.props.environmentsById}
                            lifecyclePreview={this.props.lifecyclePreview}/>
                        <OpenDialogButton label="CHANGE"
                            permission={{
                                permission: Permission.ProcessEdit,
                                project: this.props.deploymentProcess.ProjectId,
                            }}>
                            <SelectLifecycle projectId={this.props.deploymentProcess.ProjectId}
                                saveDone={() => this.props.onDataChanged()}/>
                        </OpenDialogButton>
                    </div>}
                </PermissionCheck>
                <hr/>
                <PermissionCheck permission={Permission.LibraryVariableSetView}
                    alternate={<Callout type={CalloutType.Information}>
                        The {Permission.LibraryVariableSetView} permission is required to view any included
                        script modules
                    </Callout>}>
                    {this.props.includedScriptModules && <div>
                        <h4>Script modules</h4>
                        {this.hasScriptModules()
                        ? <p className={styles.scriptModulesStatus}>
                            Included script modules:
                        </p>
                        : <div>
                            <p>No script modules have been included</p>
                            <Note>
                                Modules can be created in the <InternalLink
                                to={routeLinks.library.scripts.root}>Library</InternalLink>
                            </Note>
                        </div>}
                        <ul className={styles.includedScriptModules}>
                            {this.props.includedScriptModules.map(sm => <li key={sm.Id}>
                                <InternalLink to={routeLinks.library.script(sm.Id)}>{sm.Name}</InternalLink>
                            </li>)}
                        </ul>
                        <OpenDialogButton label={this.hasScriptModules() ? "CHANGE" : "INCLUDE"}
                            permission={{
                                permission: Permission.ProcessEdit,
                                project: this.props.deploymentProcess.ProjectId,
                            }}>
                            <SelectScriptModules projectId={this.props.deploymentProcess.ProjectId}
                                saveDone={() => this.props.onDataChanged()}/>
                        </OpenDialogButton>
                    </div>}
                </PermissionCheck>
            </div>
        );
    }

    private hasScriptModules() {
        return this.props.includedScriptModules.length > 0;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/DeploymentProcess/SideBar.tsx